import { AttachMoneyOutlined } from "@mui/icons-material";
import { Alert, Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useSnackbarContext } from "../../context/SnackbarContext";
import { usePaymentRetrialQuery } from "../../hooks/payment/usePaymentRetrialQuery";

export const OverdueBanner = () => {
  const { t } = useTranslation();
  const { paymentRetrialURL, isPaymentRetrialError } = usePaymentRetrialQuery();
  const { showSnackbar } = useSnackbarContext();

  const handleRedirect = () => {
    if (isPaymentRetrialError) {
      showSnackbar({
        message: t("TEXT.PAYMENT.ERRORS.MANAGE_PAYMENT_FAILED"),
        color: "error",
      });
      return;
    }

    if (paymentRetrialURL) {
      window.location.href = paymentRetrialURL;
    }
  };

  return (
    <Alert
      severity="error"
      variant="filled"
      sx={{
        display: "flex",
        alignItems: "center",
        fontSize: "16px",
      }}
      action={
        <Button
          variant="contained"
          color="primary"
          startIcon={<AttachMoneyOutlined />}
          onClick={handleRedirect}
        >
          {t("TEXT.SETTINGS.RETRY_PYMENT_NOW")}
        </Button>
      }
    >
      {t("ALERTS.OVERDUE_PAYMENT")}
    </Alert>
  );
};
